module.exports = __webpack_public_path__ + "img/cooking.ba3f9a24.svg";